import { actionType } from './actions';

const initialState = {
    addNewClass: {
        portfolioId: '',
        edgarClassId: '',
        name: '',
        cusip: '',
        formerlyKnownAsNames: '',
        tickerSymbol: '',
        taCode: '',
        secEffectiveDate: '',
        fundGroup: '',
        clientCode: '',
        fiscalYearEnd: '',
        isSharesOfBeneficialInterest: '',
        minInitialPurchase: '',
        minSubsequentPurchase: '',
        retirementMinPurchase: '',
        retirementSubsequentPurchase: '',
        federalId: '',
        conversionDate: '',
        launchDate: '',
        transferAgents: ''
    },
    editClass: {
        classId: '',
        portfolioId: '',
        edgarClassId: '',
        name: '',
        cusip: '',
        formerlyKnownAsNames: '',
        tickerSymbol: '',
        taCode: '',
        secEffectiveDate: '',
        fundGroup: '',
        clientCode: '',
        fiscalYearEnd: '',
        isSharesOfBeneficialInterest: '',
        minInitialPurchase: '',
        minSubsequentPurchase: '',
        retirementMinPurchase: '',
        retirementSubsequentPurchase: '',
        federalId: '',
        conversionDate: '',
        launchDate: '',
        transferAgents: ''
    },
    viewClass: {
        classId: '',
        portfolioId: '',
        edgarClassId: '',
        name: '',
        cusip: '',
        formerlyKnownAsNames: '',
        tickerSymbol: '',
        taCode: '',
        secEffectiveDate: '',
        fundGroup: '',
        clientCode: '',
        fiscalYearEnd: '',
        isSharesOfBeneficialInterest: '',
        minInitialPurchase: '',
        minSubsequentPurchase: '',
        retirementMinPurchase: '',
        retirementSubsequentPurchase: '',
        federalId: '',
        conversionDate: '',
        launchDate: '',
        transferAgents: ''
    },
    selectedHistoryItem: {},
    classes: [],
    searchClassResults: [],
    filings: [],
    sales: [],
    adminSales: [],
    history: [],
    parentPortfolios: null,
    portfolioId: null,
    addClassVisibility: false,
    editClassVisibility: false,
    viewClassVisibility: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_CLASSES_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_CLASSES_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.SEARCH_CLASSES: {
            return {
                ...state,
                searchClassResults: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.CLEAR_SEARCH_CLASS_RESULTS: {
            return {
                ...state,
                searchClassResults: [],
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS: {
            return {
                ...state,
                editClass: action.payload,
                viewClass: action.payload,
                parentPortfolios: action.parentPortfolios,
                sales: [],
                adminSales: [],
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS_BY_ID: {
            return {
                ...state,
                editClass: action.payload,
                viewClass: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS_FILINGS: {
            return {
                ...state,
                filings: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS_SALES: {
            return {
                ...state,
                sales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS_ADMIN_SALES: {
            return {
                ...state,
                adminSales: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASS_HISTORY: {
            return {
                ...state,
                history: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_CLASSES_BY_PORTFOLIO: {
            return {
                ...state,
                classes: action.payload,
                portfolioId: action.portfolioId,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.ADD_NEW_CLASS: {
            return {
                ...state,
                classes: [action.payload, ...state.classes],
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.EDIT_CLASS: {
            return {
                ...state,
                classes: state.classes.map(c => {
                    if (c.classId === action.payload.classId) {
                        return action.payload;
                    }
                    return c;
                }),
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_ADD_NEW_CLASS_PAYLOAD: {
            return {
                ...state,
                addNewClass: action.payload
            };
        }

        case actionType.UPDATE_EDIT_CLASS_PAYLOAD: {
            return {
                ...state,
                editClass: action.payload
            };
        }

        case actionType.UPDATE_CLASS_HISTORY_ITEM_SELECTED: {
            return {
                ...state,
                selectedHistoryItem: action.payload
            };
        }

        case actionType.HANDLE_ADD_CLASS_VISIBILITY: {
            return {
                ...state,
                addClassVisibility: action.visibility,
                addNewClass: {
                    portfolioId: '',
                    edgarClassId: '',
                    name: '',
                    formerlyKnownAsNames: '',
                    tickerSymbol: '',
                    transferAgents: [],
                    transferAgentJson: '',
                    secEffectiveDate: '',
                    fundGroup: '',
                    clientCode: '',
                    fiscalYearEnd: '',
                    isSharesOfBeneficialInterest: '',
                    minInitialPurchase: '',
                    minSubsequentPurchase: '',
                    retirementMinPurchase: '',
                    retirementSubsequentPurchase: ''
                }
            };
        }

        case actionType.HANDLE_EDIT_CLASS_VISIBILITY: {
            return {
                ...state,
                editClassVisibility: action.visibility
            };
        }

        case actionType.HANDLE_VIEW_CLASS_VISIBILITY: {
            return {
                ...state,
                viewClassVisibility: action.visibility
            };
        }

        case actionType.CLEAR_CLASSES_LIST: {
            return {
                ...state,
                classes: []
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/classes/reducers.js